import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue.ts";
import { feedbackToolKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useResolveFeedback(
  commentBatchId: string | undefined,
  parentId: number,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      apiClient
        .url(`/stories/feedback-tool/${commentBatchId}/resolve`)
        .patch()
        .json(),
    mutationKey: feedbackToolKeys.resolve(commentBatchId),
    onError: (err) => {
      toast.add(
        {
          description: err.message,
          title: "Error resolving feedback",
          type: "error",
        },
        {
          timeout: 5000,
        },
      );
    },
    onSuccess: async () => {
      toast.add(
        {
          title: "Feedback resolved successfully",
          type: "success",
        },
        {
          timeout: 5000,
        },
      );
      await queryClient.invalidateQueries({
        queryKey: feedbackToolKeys.feedbacks(parentId),
      });
    },
  });
}
